var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallWhiteTurnerfoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 462.6 278.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fff;}.cls-3{fill:#ffcc28;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.2,85.8H273v-45H462.6V85.9H395.2V278.1h-56Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.7,0V80L24,40,0,81.9l69.7,40L0,161.9l24,41.9,69.7-40v80h48.7v-80l69.7,40,24-41.9-69.7-40,69.7-40L212.1,40,142.4,80V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWhiteTurnerfoxLogo);
export default __webpack_public_path__ + "static/media/small_white_turnerfox_logo.400b7353c0d35a6e971229264c618d9a.svg";
export { ForwardRef as ReactComponent };